import React from 'react';
import { formatLinkBlockToUrl } from '$utilities/format';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FeaturedTaxonomy}
 */
const FeaturedTaxonomy = ({
    title,
    items
}) => {
    return (
        <div>
            <h2 className='type-style-2 mb6'>{title}</h2>
            <div className='col-12 flex md-flex-wrap featured-taxonomy-item overhang-left overflow-auto'>
                {items?.map((item, idx) =>  {
                    let url = '';
                    let label = '';
                    switch (item.__typename) {
                        case 'FeaturedTaxonomyLinkItem':
                            url = formatLinkBlockToUrl(item.link);
                            label = item.label;
                            break;
                        case 'FeaturedTaxonomyAmenityItem':
                            url = item.amenity?.url;
                            label = item.amenity?.label;
                            break;
                        case 'FeaturedTaxonomyAreaItem':
                            url = item.area?.url;
                            label = item.area?.label;
                            break;
                        case 'FeaturedTaxonomyPeriodItem':
                            url = item.period?.url;
                            label = item.period?.label;
                            break;
                    }

                    if (!url || !label) { return null; }

                    return (
                        <div
                            className='md-col-4'
                            key={`featured-taxonomy-${idx}-${item.id}`}>
                            <a
                                className='link-reset cursor-pointer inline-flex type-style-5 nowrap bg-white pl5 md-pl6 pr5 md-pr6 py4 md-py8 width-100 featured-tag'
                                href={url}>
                                <p className={'type-style-5 black'}>
                                    {label}
                                </p>
                            </a>
                        </div>
                    );
                })
                }
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default FeaturedTaxonomy;
